import React, { useState } from 'react';
import { SmartphoneIcon, CheckCircleIcon, ArrowRightIcon } from 'lucide-react';
import { Button } from './ui/Button';
export function TradeInWidget() {
  const [step, setStep] = useState(1);
  const [deviceType, setDeviceType] = useState('');
  const [brand, setBrand] = useState('');
  const [model, setModel] = useState('');
  const [condition, setCondition] = useState('');
  const [quote, setQuote] = useState(null);
  const handleNext = () => {
    if (step === 1 && deviceType) {
      setStep(2);
    } else if (step === 2 && brand) {
      setStep(3);
    } else if (step === 3 && model) {
      setStep(4);
    } else if (step === 4 && condition) {
      setQuote(Math.floor(Math.random() * 700) + 100);
      setStep(5);
    }
  };
  const resetForm = () => {
    setStep(1);
    setDeviceType('');
    setBrand('');
    setModel('');
    setCondition('');
    setQuote(null);
  };
  return <section id="consumer-trade-in" className="bg-adaptive text-adaptive py-20" data-id="element-992">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-993">
        <div className="text-center mb-12" data-id="element-994">
          <div className="inline-block px-4 py-1 bg-blue-100 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green rounded-full text-sm font-medium mb-4" data-id="element-995">
            Quick & Easy
          </div>
          <h2 className="text-3xl sm:text-4xl font-bold mb-4 text-gray-900 dark:text-white" data-id="element-996">
            Seamless Trade-In Experience
          </h2>
          <p className="text-gray-600 dark:text-gray-400 max-w-3xl mx-auto" data-id="element-997">
            Get an instant quote for your device in just a few steps. Our
            process is designed to be fast, transparent, and convenient.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-12 items-center" data-id="element-998">
          <div className="bg-white dark:bg-gray-900 rounded-xl p-8 shadow-xl border border-gray-200 dark:border-gray-800" data-id="element-999">
            <div className="mb-6" data-id="element-1000">
              <div className="flex items-center mb-4" data-id="element-1001">
                <div className="flex-1 h-2 bg-gray-100 dark:bg-gray-800 rounded-full overflow-hidden" data-id="element-1002">
                  <div className="h-full bg-blue-600 dark:bg-brand-green rounded-full transition-all duration-300" style={{
                  width: `${step / 5 * 100}%`
                }} data-id="element-1003"></div>
                </div>
                <span className="ml-4 text-sm font-medium text-gray-500 dark:text-gray-400" data-id="element-1004">
                  Step {step} of 5
                </span>
              </div>
              {step === 1 && <div className="space-y-4" data-id="element-1005">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-1006">
                    Select Device Type
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1007">
                    <button className={`p-4 border rounded-lg flex flex-col items-center transition-colors ${deviceType === 'smartphone' ? 'border-blue-500 bg-blue-50 dark:border-brand-green dark:bg-brand-green/10' : 'border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50'}`} onClick={() => setDeviceType('smartphone')} data-id="element-1008">
                      <SmartphoneIcon className="h-8 w-8 mb-2 text-blue-600 dark:text-brand-green" data-id="element-1009" />
                      <span className="text-gray-900 dark:text-white" data-id="element-1010">
                        Smartphone
                      </span>
                    </button>
                    <button className={`p-4 border rounded-lg flex flex-col items-center transition-colors ${deviceType === 'tablet' ? 'border-blue-500 bg-blue-50 dark:border-brand-green dark:bg-brand-green/10' : 'border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50'}`} onClick={() => setDeviceType('tablet')} data-id="element-1011">
                      <svg className="h-8 w-8 mb-2 text-blue-600 dark:text-brand-green" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" data-id="element-1012">
                        <rect x="4" y="2" width="16" height="20" rx="2" data-id="element-1013" />
                        <line x1="12" y1="18" x2="12" y2="18.01" data-id="element-1014" />
                      </svg>
                      <span className="text-gray-900 dark:text-white" data-id="element-1015">
                        Tablet
                      </span>
                    </button>
                  </div>
                </div>}
              {step === 2 && <div className="space-y-4" data-id="element-1016">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-1017">
                    Select Brand
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1018">
                    {['apple', 'samsung', 'google', 'other'].map(brandName => <button key={brandName} className={`p-4 border rounded-lg text-center transition-colors ${brand === brandName ? 'border-blue-500 bg-blue-50 dark:border-brand-green dark:bg-brand-green/10' : 'border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50'}`} onClick={() => setBrand(brandName)} data-id="element-1019">
                          <span className="text-gray-900 dark:text-white" data-id="element-1020">
                            {brandName.charAt(0).toUpperCase() + brandName.slice(1)}
                          </span>
                        </button>)}
                  </div>
                </div>}
              {step === 3 && <div className="space-y-4" data-id="element-1021">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-1022">
                    Select Model
                  </h3>
                  <div className="grid grid-cols-2 gap-4" data-id="element-1023">
                    {[['iphone13', 'iPhone 13 Pro'], ['iphone12', 'iPhone 12'], ['iphone11', 'iPhone 11'], ['other', 'Other']].map(([modelId, modelName]) => <button key={modelId} className={`p-4 border rounded-lg text-center transition-colors ${model === modelId ? 'border-blue-500 bg-blue-50 dark:border-brand-green dark:bg-brand-green/10' : 'border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50'}`} onClick={() => setModel(modelId)} data-id="element-1024">
                        {modelName}
                      </button>)}
                  </div>
                </div>}
              {step === 4 && <div className="space-y-4" data-id="element-1025">
                  <h3 className="text-xl font-bold text-gray-900 dark:text-white" data-id="element-1026">
                    Device Condition
                  </h3>
                  <div className="grid grid-cols-1 gap-4" data-id="element-1027">
                    {[{
                  id: 'excellent',
                  title: 'Excellent',
                  desc: 'Like new, no scratches or damage'
                }, {
                  id: 'good',
                  title: 'Good',
                  desc: 'Minor scratches, fully functional'
                }, {
                  id: 'fair',
                  title: 'Fair',
                  desc: 'Visible wear, works properly'
                }].map(conditionOption => <button key={conditionOption.id} className={`p-4 border rounded-lg text-left transition-colors ${condition === conditionOption.id ? 'border-blue-500 bg-blue-50 dark:border-brand-green dark:bg-brand-green/10' : 'border-gray-200 dark:border-gray-800 hover:border-blue-500 dark:hover:border-brand-green/50'}`} onClick={() => setCondition(conditionOption.id)} data-id="element-1028">
                        <div className="font-medium" data-id="element-1029">
                          {conditionOption.title}
                        </div>
                        <div className="text-sm text-gray-400" data-id="element-1030">
                          {conditionOption.desc}
                        </div>
                      </button>)}
                  </div>
                </div>}
              {step === 5 && <div className="text-center space-y-6" data-id="element-1031">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-blue-50 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green mb-4" data-id="element-1032">
                    <CheckCircleIcon className="h-8 w-8" data-id="element-1033" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1034">
                    Your Estimated Quote
                  </h3>
                  <div className="text-5xl font-bold text-blue-600 dark:text-brand-green" data-id="element-1035">
                    ${quote}
                  </div>
                  <p className="text-gray-600 dark:text-gray-400" data-id="element-1036">
                    This is an estimated trade-in value for your {brand} {model}{' '}
                    in {condition} condition.
                  </p>
                  <div className="pt-4 space-y-3" data-id="element-1037">
                    <Button className="w-full bg-blue-600 dark:bg-brand-green hover:bg-blue-700 dark:hover:bg-brand-green/90 text-white dark:text-black" data-id="element-1038">
                      Accept Offer
                    </Button>
                    <button className="w-full text-blue-600 dark:text-brand-green hover:text-blue-700 dark:hover:text-brand-green/90" onClick={resetForm} data-id="element-1039">
                      Try Another Device
                    </button>
                  </div>
                </div>}
            </div>
            {step < 5 && <div className="mt-6" data-id="element-1040">
                <Button className="w-full bg-blue-600 dark:bg-brand-green hover:bg-blue-700 dark:hover:bg-brand-green/90 text-white dark:text-black disabled:bg-gray-100 dark:disabled:bg-gray-800 disabled:text-gray-400 dark:disabled:text-gray-500" onClick={handleNext} disabled={step === 1 && !deviceType || step === 2 && !brand || step === 3 && !model || step === 4 && !condition} data-id="element-1041">
                  Continue
                </Button>
                {step > 1 && <button className="w-full mt-2 text-blue-600 dark:text-brand-green hover:text-blue-700 dark:hover:text-brand-green/90" onClick={() => setStep(step - 1)} data-id="element-1042">
                    Back
                  </button>}
              </div>}
          </div>
          <div className="space-y-8" data-id="element-1043">
            <h3 className="text-2xl font-bold text-gray-900 dark:text-white" data-id="element-1044">
              Why Trade In With Us?
            </h3>
            <div className="space-y-6" data-id="element-1045">
              {[{
              icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-1046" />,
              title: 'Fast & Convenient',
              description: 'Get an instant quote in minutes. No waiting, no hassle.'
            }, {
              icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 10h18M7 15h1m4 0h1m-7 4h12a3 3 0 003-3V8a3 3 0 00-3-3H6a3 3 0 00-3 3v8a3 3 0 003 3z" data-id="element-1047" />,
              title: 'Best Value Guaranteed',
              description: 'Our AI-powered pricing ensures you get the highest market value for your device.'
            }, {
              icon: <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" data-id="element-1048" />,
              title: 'Secure & Trustworthy',
              description: 'Your data is wiped securely, and all transactions are protected.'
            }].map((feature, index) => <div key={index} className="flex items-start" data-id="element-1049">
                  <div className="flex-shrink-0" data-id="element-1050">
                    <div className="flex items-center justify-center h-12 w-12 rounded-md bg-blue-50 dark:bg-brand-green/10 text-blue-600 dark:text-brand-green" data-id="element-1051">
                      <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" data-id="element-1052">
                        {feature.icon}
                      </svg>
                    </div>
                  </div>
                  <div className="ml-4" data-id="element-1053">
                    <h4 className="text-lg font-medium" data-id="element-1054">{feature.title}</h4>
                    <p className="mt-2 text-gray-400" data-id="element-1055">{feature.description}</p>
                  </div>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}